import { Link, useNavigate } from 'react-router-dom';
import { ButtonBack } from '../../common/Button/ButtonBack';
import {
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PageAbsolutePath } from '../../../consts/Common';
import Links from '../../common/Widgets/Links';
import { useContext } from 'react';
import { SiteContext } from '../../../context/SiteContext';

const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;
const chevronRightComponent = <FontAwesomeIcon icon={faChevronRight} />;

const getLinkContentFor = (url: string): JSX.Element => {
  return (
    <div className='dealer-link-item'>
      <span className='dealer-link-icon'>{chevronRightComponent}</span>
      <Link to={url}>Find out more</Link>
    </div>
  );
};

const getEmptyRowWithHrTag = (): JSX.Element => {
  return (
    <tr>
      <td colSpan={2}>
        <hr />
      </td>
    </tr>
  );
};

const HelpPage = () => {
  const navigate = useNavigate();

  const { site } = useContext(SiteContext);

  const { brand } = site;

  const { brandDisplayFullName, brandPhoneNumbers } = brand;

  const {
    quotesAndRenewalsNumber,
    changesAndComplaintsNumber,
    claimsNumber,
    excessReturnVoucherNumber,
    glassHelplineNumber,
    lostKeysNumber,
    breakdownAssistanceNumber,
    europeanBreakdownAssistanceNumber
  } = brandPhoneNumbers;

  const goBack = (): void => {
    navigate(PageAbsolutePath.Insurance.SiteMap);
  };

  return (
    <div>
      <Links
        id='back-link'
        title=''
        items={[{ to: '../sitemap', text: 'Back' }]}
        icon={chevronLeftComponent}
      />
      <br />
      <table className='dealer-resource-page'>
        <tr>
          <td className='expand'>
            <p>Upload proof of no claims</p>
          </td>
          <td className='fixed'>
            {getLinkContentFor(PageAbsolutePath.Insurance.ProofOfNcd)}
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>
            <p>Make a Motor Insurance claim</p>
          </td>
          <td className='fixed'>
            {getLinkContentFor(PageAbsolutePath.Insurance.MotorInsuranceClaim)}
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>
            <p>Frequently asked questions</p>
          </td>
          <td className='fixed'>
            {getLinkContentFor(PageAbsolutePath.Insurance.FaqsPage)}
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>
            <p>Policy documents</p>
          </td>
          <td className='fixed'>
            {getLinkContentFor(PageAbsolutePath.Insurance.PolicyDocuments)}
          </td>
        </tr>
        <br />
        <tr>
          <td colSpan={2}>
            <h2>Contact information</h2>
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td colSpan={2}>
            <b>Mon-Thurs 8.30am-7.30pm, Fri 9am-6pm, Sat 9am-5pm</b>
          </td>
        </tr>
        <br />
        <tr>
          <td className='expand'>Quotes and renewals</td>
          <td className='fixed'>
            <a className='in-text' href={`tel:${quotesAndRenewalsNumber}`}>
              {quotesAndRenewalsNumber}
            </a>
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>Policy changes</td>
          <td className='fixed'>
            <a className='in-text' href={`tel:${changesAndComplaintsNumber}`}>
              {changesAndComplaintsNumber}
            </a>
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>Complaints</td>
          <td className='fixed'>
            <a className='in-text' href={`tel:${changesAndComplaintsNumber}`}>
              {changesAndComplaintsNumber}
            </a>
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td colSpan={2}>
            <b>24 hours a day, 7 days a week:</b>
          </td>
        </tr>
        <br />
        <tr>
          <td className='expand'>Motor Insurance claims and accidents</td>
          <td className='fixed'>
            <a className='in-text' href={`tel:${claimsNumber}`}>
              {claimsNumber}
            </a>
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>Excess Return Voucher claims</td>
          <td className='fixed'>
            <a className='in-text' href={`tel:${excessReturnVoucherNumber}`}>
              {excessReturnVoucherNumber}
            </a>
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>Breakdown assistance</td>
          <td className='fixed'>
            <a className='in-text' href={`tel:${breakdownAssistanceNumber}`}>
              {breakdownAssistanceNumber}
            </a>
          </td>
        </tr>
        <tr>
          <td className='expand' style={{ fontWeight: 'lighter' }}>
            (when purchased with your insurance policy)
          </td>
          <td className='fixed'>
            <a
              className='in-text'
              href={`tel:${europeanBreakdownAssistanceNumber}`}>
              {europeanBreakdownAssistanceNumber}
            </a>
            <span> (from Europe)</span>
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>Glass helpline</td>
          <td className='fixed'>
            <a className='in-text' href={`tel:${glassHelplineNumber}`}>
              {glassHelplineNumber}
            </a>
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td className='expand'>Lost or stolen keys</td>
          <td className='fixed'>
            <a className='in-text' href={`tel:${lostKeysNumber}`}>
              {lostKeysNumber}
            </a>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>(optional cover)</td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td colSpan={2} className='expand'>
            Postal address
          </td>
        </tr>
        {getEmptyRowWithHrTag()}
        <tr>
          <td colSpan={2} className='expand'>
            {brandDisplayFullName} Insurance, Car Care Plan Ltd, Second Floor,
            Aztec Centre, Aztec West, Bristol BS32 4TD
          </td>
        </tr>
      </table>
      <br />
      <div className='flex-row'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
      </div>
    </div>
  );
};

export default HelpPage;
